import type { PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

import type { StoreSettingsPayload } from '@jane/business-admin/types';

interface PosSyncMap {
  isJanePosSynced: boolean;
  posSource: string | null;
  posSynced: boolean;
}

interface Props {
  hasDuplicationErrors?: boolean;
  isReadOnly?: boolean;
  posSyncMap: PosSyncMap;
  storeSettings?: StoreSettingsPayload;
}

const SpecialsModalContext = createContext<Props>({
  posSyncMap: { posSource: '', posSynced: false, isJanePosSynced: false },
});
SpecialsModalContext.displayName = 'SpecialsModal';

export const useSpecialsModal = () => useContext(SpecialsModalContext);

export const SpecialsModalProvider = ({
  children,
  hasDuplicationErrors,
  isReadOnly,
  posSyncMap,
  storeSettings,
}: PropsWithChildren<Props>) => {
  const contextValue = useMemo(
    () => ({
      posSyncMap,
      hasDuplicationErrors,
      isReadOnly,
      storeSettings,
    }),
    [posSyncMap, hasDuplicationErrors, isReadOnly, storeSettings]
  );

  return (
    <SpecialsModalContext.Provider value={contextValue}>
      {children}
    </SpecialsModalContext.Provider>
  );
};
